import isEmpty from 'lodash-es/isEmpty';

import { isValidPhoneOnlySite, isValidTimeFormat, isValidTimeRange } from '@ecp/common/src/utils/InputValidateUtils';

export const diviOptions = [
  { value: 'Y', label: '웰스토리와 동일' },
  { value: 'N', label: '직접입력' },
];

export const validators = {
  customerCenterTel: [
    {
      when: ['created', 'updated'],
      message: '전화번호를 입력해주세요.',
      validator: ({ customerCenterTel }) => !isEmpty(customerCenterTel),
    },
    {
      when: ['created', 'updated'],
      message: '형식에 맞게 입력해주세요.',
      validator: ({ customerCenterTel }) => isValidPhoneOnlySite(customerCenterTel),
    },
  ],
  customerCenterOperatingStartHh: [
    {
      when: ['created', 'updated'],
      message: '운영 시간을 입력해주세요.',
      validator: ({ customerCenterOperatingStartHh }) => !isEmpty(customerCenterOperatingStartHh),
    },
    {
      when: ['created', 'updated'],
      message: '형식에 맞게 입력해주세요.',
      validator: ({ customerCenterOperatingStartHh }) => isValidTimeFormat(customerCenterOperatingStartHh),
    },
    {
      when: ['created', 'updated'],
      message: '시작 종료 시간을 바르게 입력해주세요.',
      validator: ({ customerCenterOperatingStartHh, customerCenterOperatingEndHh }) =>
        isValidTimeRange(customerCenterOperatingStartHh, customerCenterOperatingEndHh),
    },
  ],
  customerCenterOperatingEndHh: [
    {
      when: ['created', 'updated'],
      message: '운영 시간을 입력해주세요.',
      validator: ({ customerCenterOperatingEndHh }) => !isEmpty(customerCenterOperatingEndHh),
    },
    {
      when: ['created', 'updated'],
      message: '형식에 맞게 입력해주세요.',
      validator: ({ customerCenterOperatingEndHh }) => isValidTimeFormat(customerCenterOperatingEndHh),
    },
    {
      when: ['created', 'updated'],
      message: '시작 종료 시간을 바르게 입력해주세요.',
      validator: ({ customerCenterOperatingStartHh, customerCenterOperatingEndHh }) =>
        isValidTimeRange(customerCenterOperatingStartHh, customerCenterOperatingEndHh),
    },
  ],
  customerCenterLunchStartHh: [
    {
      when: ['created', 'updated'],
      message: '점심 시간을 입력해주세요.',
      validator: ({ customerCenterLunchStartHh }) => !isEmpty(customerCenterLunchStartHh),
    },
    {
      when: ['created', 'updated'],
      message: '형식에 맞게 입력해주세요.',
      validator: ({ customerCenterLunchStartHh }) => isValidTimeFormat(customerCenterLunchStartHh),
    },
    {
      when: ['created', 'updated'],
      message: '시작 종료 시간을 바르게 입력해주세요.',
      validator: ({ customerCenterLunchStartHh, customerCenterLunchEndHh }) =>
        isValidTimeRange(customerCenterLunchStartHh, customerCenterLunchEndHh),
    },
  ],
  customerCenterLunchEndHh: [
    {
      when: ['created', 'updated'],
      message: '점심 시간을 입력해주세요.',
      validator: ({ customerCenterLunchEndHh }) => !isEmpty(customerCenterLunchEndHh),
    },
    {
      when: ['created', 'updated'],
      message: '형식에 맞게 입력해주세요.',
      validator: ({ customerCenterLunchEndHh }) => isValidTimeFormat(customerCenterLunchEndHh),
    },
    {
      when: ['created', 'updated'],
      message: '시작 종료 시간을 바르게 입력해주세요.',
      validator: ({ customerCenterLunchStartHh, customerCenterLunchEndHh }) =>
        isValidTimeRange(customerCenterLunchStartHh, customerCenterLunchEndHh),
    },
  ],
  customerCenterGuide: [
    {
      when: ['created', 'updated'],
      message: '안내사항을 입력해주세요.',
      validator: ({ customerCenterGuide }) => !isEmpty(customerCenterGuide),
    },
  ],
};

export const initialErrors = {
  customerCenterTel: undefined,
  customerCenterOperatingStartHh: undefined,
  customerCenterOperatingEndHh: undefined,
  customerCenterLunchStartHh: undefined,
  customerCenterLunchEndHh: undefined,
  customerCenterGuide: undefined,
  welmallCustomerCenterUseYn: undefined,
};

export const initialForm = {
  customerCenterTel: '',
  customerCenterOperatingStartHh: '',
  customerCenterOperatingEndHh: '',
  customerCenterLunchStartHh: '',
  customerCenterLunchEndHh: '',
  customerCenterGuide: '',
  welmallCustomerCenterUseYn: 'Y',
};
